import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAllocineComponent } from './simple-icons-allocine.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAllocineComponent ],
    exports:      [ SimpleIconsAllocineComponent ],
    bootstrap:    []
})
export class SimpleIconsAllocineModule {}
